import { useTranslation } from 'react-i18next';
import z from 'zod';

export function useCreateAndUpdateBewertungSchema() {
  const { t } = useTranslation();

  const schema = z.object({
    beurteilung: z.string().max(400, {
      message: t(
        'domain.mitarbeiter.rotationsplan.rotationsplaene.createBewertung.fields.beurteilung.tooLong',
      ),
    }),
    sterne: z.int().min(1).max(5),
  });

  return schema;
}
